module.exports = __webpack_public_path__ + "static/media/picture.078cf360.svg";